import { COUPON } from 'src/constants';

export const LOAD_COUPONS = `LOAD_${COUPON}S`;
export const LOAD_COUPON = `LOAD_${COUPON}`;
export const PERSIST_COUPON = `PERSIST_${COUPON}`;
export const CREATE_OR_UPDATE_COUPON = `CREATE_OR_UPDATE_${COUPON}`;
export const DELETE_COUPON = `DELETE_${COUPON}`;
export const LOAD_COUPON_DETAILS = `LOAD_${COUPON}_DETAILS`;
export const GET_COUPON_ORDERS = `LOAD_${COUPON}_ORDERS`;
